var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlasticToys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31.971,
    viewBox: "0 0 32 31.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-1293 -839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(1283.973 830)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "Path_11",
    "data-name": "Path 11",
    d: "M36.447,13.817l-.042-.049a16.01,16.01,0,0,0-9.6-4.664h0A16.421,16.421,0,0,0,25.018,9a15.933,15.933,0,0,0-9.745,3.334L15.2,12.4A15.961,15.961,0,0,0,10.512,31.72h0a16.01,16.01,0,0,0,30.369-4.552h0a16.824,16.824,0,0,0,.146-2.158,15.94,15.94,0,0,0-4.58-11.193Zm-4.176,3.7a3.07,3.07,0,0,0-.585-1.65c.4-.445,1.455-1.162,3.835-.961a14.617,14.617,0,0,1,3.933,8.13,11.033,11.033,0,0,0-7.149-5.52Zm-3.077,1.928a1.74,1.74,0,1,1,1.74-1.74,1.74,1.74,0,0,1-1.74,1.74Zm1.476-4.483a3.028,3.028,0,0,0-1.476-.39h0a8.471,8.471,0,0,0-.9-3.8,14.617,14.617,0,0,1,5.743,2.742,4.914,4.914,0,0,0-3.369,1.448Zm-4.26-4.5a6.821,6.821,0,0,1,1.35,4.469,3.23,3.23,0,0,0-.626.432,11.137,11.137,0,0,0-8.443-3.48,14.52,14.52,0,0,1,6.327-1.49A9.282,9.282,0,0,1,26.41,10.462Zm-10.441,3.1c6.181-1.323,9.466,1.907,10.344,2.951a3.07,3.07,0,0,0-.237,1.183,2.694,2.694,0,0,0,0,.341C23.34,18.418,14.438,20.318,11.02,29.3A14.791,14.791,0,0,1,10.4,25.01a14.617,14.617,0,0,1,5.569-11.443ZM11.862,31.309c2.784-10.128,12.529-11.7,14.708-11.931A3.146,3.146,0,0,0,28.7,20.77c.626,1.914,3.049,10.733-2.659,18.794a5.538,5.538,0,0,1-1.023.063,14.617,14.617,0,0,1-13.17-8.318Zm16.01,8.04A22.808,22.808,0,0,0,30.134,20.68a3.139,3.139,0,0,0,1.97-1.8c1.58.369,6.021,1.942,7.392,8.144a14.652,14.652,0,0,1-11.638,12.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticToys);
export default __webpack_public_path__ + "static/media/plasticToys.50c3a079d08b2b4f5dd55ac5fbdfe891.svg";
export { ForwardRef as ReactComponent };